import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const AvatarContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;

  > img {
    height: 150px;
    width: 150px;
    object-fit: cover;
    border-radius: 50%;
    margin-bottom: 24px;
  }
`;

export const Name = styled.h2`
  font-weight: bold;
  font-size: 36px;
  line-height: 120%;
  text-align: center;
  color: var(--primary);
  margin-bottom: 8px;

  @media (max-width: 800px) {
    font-size: 24px;
  }
`;

export const Bio = styled.p`
  font-size: 16px;
  line-height: 120%;
  text-align: center;
  color: #222;
  margin-bottom: 40px;
`;

export const Card = styled.div`
  width: 100%;
  background: var(--white-darker);
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  border-radius: 8px;

  > label {
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    color: var(--gray-9);
    text-transform: uppercase;
    margin-bottom: 24px;
  }

  > a {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 16px;
    color: var(--black-3);

    :last-child {
      margin: 0;
    }
  }

  > a svg {
    margin-right: 16px;
  }
`;

export const CenterWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Spin = styled.div`
  width: 50px;
  height: 50px;
  border: 8px solid var(--gray-d);
  border-top: 8px solid var(--gray-9);
  border-radius: 50%;
  animation: 1s spin linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
